module.exports = __webpack_public_path__ + "static/media/pro_build_profile.d5445866.jpg";